import { Box } from "@mui/material";
import Appheader from "components/app/Appheader";
import Appmainbar from "components/app/Appmainbar";
import React, { useState } from "react";
import { Outlet } from "react-router-dom";

export default function Root({ handleLogout, decoded }) {
  // ← أضف decoded هنا
  const [isPinned, setIsPinned] = useState(false);

  const handleDrawerToggle = () => {
    setIsPinned((prev) => !prev);
  };

  return (
    <Box>
      <Appheader onMenuClick={handleDrawerToggle} handleLogout={handleLogout} />

      <Appmainbar
        decoded={decoded} // ← تمرير decoded إلى Appmainbar
        isPinned={isPinned}
        handleDrawerToggle={handleDrawerToggle}
      />

      <Box
        sx={{
          marginLeft: `${isPinned ? "260px" : "69px"}`,
          marginTop: "64px",
          width: `calc(100% - ${isPinned ? "260px" : "75px"})`,
          height: `calc(100% - 50px)`,
          maxHeight: `calc(100% - 50px)`,
          transition: "margin 0.3s ease",
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}
